import { render, staticRenderFns } from "./ExamenPorAlumno.vue?vue&type=template&id=2b7a070f&scoped=true&"
import script from "./ExamenPorAlumno.vue?vue&type=script&lang=js&"
export * from "./ExamenPorAlumno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7a070f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
